/*
 * hev-skate.js
 * Things ride the twirly cord in the Behold section (ENG-2254). The cord is two
 * stacked images (back strand, front strand) in a 640 x 679 unit box, shared by
 * the desktop and mobile layouts. The route is drawn from the tail up to the
 * right edge and ridden backwards: a rider enters at the right edge behind the
 * cord, comes out in front at the loop, goes round it and leaves off the bottom.
 *
 * One ride every 30s (start to start), the first 20s after load. Most rides are
 * the roller skate; every 4th is one of the others in turn (shrimp, hedgehog,
 * pie, basketball, pizza, loonie, then the skier when the section turns him on). The skate and
 * skier sit on the route by two contact points; round things roll without
 * slipping, and the hedgehog rocks on his outline. Spec: the "Cord Skate"
 * handoff artifact.
 */
(function () {

  var NS = 'http://www.w3.org/2000/svg';
  var BOX_W = 640;
  var PATH_FRONT =
    'M17.52,677.01c18.36-6.64,50.59-18.77,70.85-26.16,19.08-6.96,38.04-18.37,56.02-28.03,20.56-11.05,40.59-23.08,60-36.04,38.83-25.91,75.2-55.51,108.41-88.3,40.92-40.4,83.67-85.59,96.12-143.11,12.03-55.58,19.17-115.44-9.54-167.92C370.68,134.99,309.77,92.22,248.05,98.13c-33.54,3.21-64.21,27.43-79.6,56.95-14.22,27.27-16.94,56.78-8.89,86.34,8.38,30.79,32.98,56.33,59.85,72.82,24.97,15.32,68.48,27.3,98.01,27.36';
  var PATH_BACK =
    'M317.38,341.15c62.29.21,129.48-31.33,190.32-67.88,30.17-18.12,56.05-43.66,78.4-70.9,23.52-28.65,41.11-62.47,56.68-95.93';

  var INTERVAL_SECONDS = 30;
  var FIRST_DELAY = 20;
  var EVERY = 4;
  var ORDER = ['shrimp', 'hedgehog', 'pie', 'basketball', 'pizza', 'loonie', 'skier'];
  var RUNUP = 260;
  /* Extra run at the exit so even the biggest rider is off the bottom before
     its ride ends; ride times are stretched to keep the pace on the cord. */
  var EXIT_EXTRA = 420;

  var SKATE = { seconds: 6, w: 480, rear: { x: 64.33, y: 519.47 }, front: { x: 330.33, y: 519.47 } };
  var SKIER = { seconds: 6, w: 640, width: 125, rear: { x: 141, y: 596 }, front: { x: 512, y: 596 } };

  /* Round riders: size on the cord (units), and the diameter in image pixels of
     the circle each rolls on (the shrimp's is fitted to its curl). The hedgehog
     isn't round, so he rolls on his outline (hull) instead. */
  var ROLLERS = {
    shrimp: { diameter: 90, fit: 266.8, seconds: 6 },
    hedgehog: { diameter: 92, fit: 381.5, seconds: 7, hull: {"n":160,"perimeter":1201.32,"x":[6.3,8.5,10.9,13.5,16.4,19.6,23.0,26.6,30.5,34.6,38.9,43.4,48.2,53.1,58.3,63.6,69.1,74.8,80.6,86.6,92.8,99.1,105.5,112.0,118.6,125.3,132.1,139.0,146.0,153.0,160.0,167.1,174.2,181.3,188.4,195.5,202.5,209.5,216.5,223.4,230.3,237.0,243.7,250.3,256.7,263.1,269.3,275.4,281.3,287.1,292.7,298.1,303.4,308.5,313.3,318.0,322.5,326.7,330.8,334.6,338.2,341.5,344.6,347.5,350.1,352.5,354.6,356.5,358.1,359.5,360.5,361.4,361.9,362.2,362.2,362.0,361.4,360.6,359.6,358.2,356.6,354.7,352.6,350.2,347.5,344.6,341.4,338.0,334.3,330.4,326.2,321.8,317.2,312.4,307.3,302.1,296.6,290.9,285.1,279.1,272.9,266.6,260.1,253.5,246.8,239.9,233.0,225.9,218.8,211.6,204.4,197.1,189.8,182.5,175.1,167.8,160.5,153.2,146.0,138.8,131.7,124.7,117.8,111.0,104.3,97.7,91.2,85.0,78.8,72.9,67.1,61.5,56.1,50.9,45.9,41.2,36.6,32.3,28.3,24.4,20.9,17.6,14.5,11.7,9.2,7.0,5.0,3.3,1.9,0.7,-0.2,-0.8,-1.1,-1.1,-0.9,-0.4,0.4,1.5,2.8,4.4],"y":[153.7,146.2,138.7,131.4,124.1,117.0,110.0,103.1,96.4,89.9,83.5,77.3,71.3,65.5,59.9,54.5,49.4,44.4,39.8,35.4,31.2,27.4,23.8,20.4,17.4,14.7,12.3,10.1,8.3,6.8,5.6,4.8,4.2,4.0,4.1,4.5,5.3,6.3,7.7,9.4,11.4,13.7,16.3,19.3,22.5,26.0,29.8,33.9,38.2,42.8,47.7,52.8,58.1,63.7,69.5,75.5,81.7,88.0,94.6,101.3,108.2,115.2,122.4,129.7,137.1,144.6,152.1,159.8,167.5,175.3,183.1,190.9,198.8,206.7,214.5,222.4,230.2,237.9,245.6,253.3,260.8,268.3,275.7,283.0,290.1,297.1,304.0,310.7,317.3,323.6,329.8,335.8,341.6,347.2,352.6,357.7,362.6,367.2,371.7,375.8,379.7,383.3,386.7,389.7,392.5,395.0,397.2,399.1,400.8,402.1,403.1,403.8,404.2,404.4,404.2,403.7,402.9,401.8,400.5,398.8,396.8,394.6,392.0,389.2,386.1,382.8,379.1,375.3,371.1,366.7,362.1,357.2,352.1,346.8,341.2,335.5,329.5,323.4,317.1,310.6,304.0,297.2,290.3,283.2,276.0,268.7,261.3,253.8,246.3,238.7,231.0,223.3,215.5,207.7,200.0,192.2,184.4,176.7,169.0,161.3],"nx":[-0.967,-0.957,-0.946,-0.934,-0.921,-0.907,-0.892,-0.875,-0.857,-0.838,-0.818,-0.796,-0.773,-0.749,-0.723,-0.697,-0.668,-0.639,-0.608,-0.576,-0.542,-0.508,-0.472,-0.434,-0.396,-0.356,-0.316,-0.274,-0.231,-0.188,-0.144,-0.099,-0.054,-0.009,0.036,0.082,0.127,0.172,0.216,0.26,0.303,0.345,0.386,0.426,0.465,0.503,0.539,0.574,0.607,0.639,0.67,0.699,0.726,0.752,0.777,0.8,0.822,0.842,0.861,0.878,0.895,0.91,0.924,0.936,0.948,0.958,0.967,0.975,0.982,0.988,0.993,0.996,0.999,1.0,1.0,0.999,0.996,0.993,0.988,0.982,0.974,0.965,0.955,0.943,0.93,0.915,0.899,0.881,0.862,0.841,0.818,0.794,0.769,0.742,0.713,0.683,0.652,0.619,0.586,0.551,0.515,0.478,0.44,0.402,0.363,0.323,0.283,0.242,0.201,0.16,0.119,0.078,0.037,-0.004,-0.045,-0.086,-0.127,-0.167,-0.207,-0.247,-0.286,-0.325,-0.363,-0.4,-0.437,-0.473,-0.509,-0.543,-0.577,-0.61,-0.642,-0.672,-0.702,-0.73,-0.757,-0.783,-0.807,-0.83,-0.851,-0.872,-0.89,-0.907,-0.923,-0.937,-0.95,-0.961,-0.971,-0.979,-0.986,-0.991,-0.995,-0.998,-1.0,-1.0,-0.999,-0.996,-0.993,-0.988,-0.982,-0.975],"ny":[-0.256,-0.29,-0.323,-0.356,-0.389,-0.421,-0.453,-0.484,-0.515,-0.546,-0.576,-0.605,-0.634,-0.663,-0.69,-0.717,-0.744,-0.769,-0.794,-0.817,-0.84,-0.862,-0.882,-0.901,-0.918,-0.934,-0.949,-0.962,-0.973,-0.982,-0.99,-0.995,-0.999,-1.0,-0.999,-0.997,-0.992,-0.985,-0.976,-0.966,-0.953,-0.939,-0.922,-0.905,-0.885,-0.864,-0.842,-0.819,-0.794,-0.769,-0.743,-0.715,-0.687,-0.659,-0.63,-0.6,-0.57,-0.54,-0.509,-0.478,-0.446,-0.415,-0.383,-0.351,-0.319,-0.286,-0.253,-0.22,-0.187,-0.154,-0.121,-0.087,-0.053,-0.019,0.015,0.05,0.085,0.12,0.155,0.19,0.225,0.261,0.296,0.332,0.367,0.403,0.438,0.473,0.507,0.541,0.575,0.607,0.639,0.671,0.701,0.73,0.758,0.785,0.811,0.835,0.857,0.878,0.898,0.916,0.932,0.946,0.959,0.97,0.979,0.987,0.993,0.997,0.999,1.0,0.999,0.996,0.992,0.986,0.978,0.969,0.958,0.946,0.932,0.916,0.899,0.881,0.861,0.839,0.817,0.793,0.767,0.74,0.712,0.684,0.653,0.622,0.591,0.558,0.524,0.49,0.456,0.42,0.385,0.349,0.313,0.277,0.24,0.204,0.168,0.131,0.095,0.059,0.023,-0.013,-0.049,-0.084,-0.119,-0.154,-0.188,-0.223]} },
    pie: { diameter: 100, fit: 361.5, seconds: 7 },
    basketball: { diameter: 96, fit: 360, seconds: 6 },
    pizza: { diameter: 100, fit: 361, seconds: 7 },
    loonie: { diameter: 70, fit: 359.5, seconds: 6 }
  };

  var desktopMq = window.matchMedia('(min-width: 750px)');

  /* The mobile design draws the skate a little larger against the cord. */
  function carWidth() {
    return desktopMq.matches ? 105 : 112;
  }

  function init(box) {
    var car = box.querySelector('[data-hev-skate]');
    if (!car) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    var pF = document.createElementNS(NS, 'path');
    var pB = document.createElementNS(NS, 'path');
    pF.setAttribute('d', PATH_FRONT);
    pB.setAttribute('d', PATH_BACK);
    svg.appendChild(pF);
    svg.appendChild(pB);
    box.appendChild(svg);

    var LF = pF.getTotalLength();
    var LB = pB.getTotalLength();
    var TOTAL = LF + LB;
    var S_END = TOTAL + RUNUP + EXIT_EXTRA;
    var S_START;
    var scale = 1;

    function tangent(p, len, atEnd) {
      var a = p.getPointAtLength(atEnd ? len - 1 : 0);
      var b = p.getPointAtLength(atEnd ? len : 1);
      var m = Math.hypot(b.x - a.x, b.y - a.y) || 1;
      return { x: (b.x - a.x) / m, y: (b.y - a.y) / m };
    }
    var T0 = tangent(pF, LF, false);
    var T1 = tangent(pB, LB, true);
    var P0 = pF.getPointAtLength(0);
    var P1 = pB.getPointAtLength(LB);

    /* Distance u along the route as drawn, extended straight past each end. */
    function pathAt(u) {
      if (u < 0) return { x: P0.x + T0.x * u, y: P0.y + T0.y * u };
      if (u > TOTAL) return { x: P1.x + T1.x * (u - TOTAL), y: P1.y + T1.y * (u - TOTAL) };
      return u <= LF ? pF.getPointAtLength(u) : pB.getPointAtLength(u - LF);
    }
    /* s is distance travelled; the ride runs the drawn route backwards. */
    function pointAt(s) {
      return pathAt(TOTAL - s);
    }
    function isBehind(s) {
      return TOTAL - s > LF;
    }
    /* Unit vector pointing off the cord (left of the route as drawn). */
    function offCord(s) {
      var r = pointAt(s - 8);
      var f = pointAt(s + 8);
      var tx = r.x - f.x;
      var ty = r.y - f.y;
      var m = Math.hypot(tx, ty) || 1;
      return { x: ty / m, y: -tx / m };
    }

    function measure() {
      var w = carWidth();
      var k = w / SKATE.w;
      S_START = -RUNUP - ((SKATE.front.x - SKATE.rear.x) * k) / 2 - w;
      scale = box.clientWidth / BOX_W;
    }
    measure();

    /* Skate and skier: each contact point sits on the route, so the angle comes
       from the two of them. Riding backwards flips the art to face forward. */
    function vehicle(el, spec, widthFn) {
      return {
        el: el,
        seconds: spec.seconds,
        place: function (s) {
          var w = widthFn();
          var k = w / spec.w;
          var base = (spec.front.x - spec.rear.x) * k;
          var r = pointAt(s - base / 2);
          var f = pointAt(s + base / 2);
          var ang = (Math.atan2(f.y - r.y, f.x - r.x) * 180) / Math.PI + 180;
          var ox = (spec.rear.x + spec.front.x) / 2;
          el.style.transform =
            'translate(' + ((r.x + f.x) / 2) * scale + 'px,' + ((r.y + f.y) / 2) * scale + 'px) rotate(' + ang + 'deg) scale(' + -k * scale + ',' + k * scale + ') translate(' + -ox + 'px,' + -spec.rear.y + 'px)';
          el.classList.toggle('is-behind', isBehind(s));
        }
      };
    }

    /* A round rider touches the route on the side away from the cord and turns
       without slipping: by the distance its centre travels over its radius,
       measured once along the whole ride (built in idle time before its first
       ride, not at load). */
    function roller(el, c) {
      var w = +el.getAttribute('width');
      var h = +el.getAttribute('height');
      var R = c.diameter / 2;
      var k = c.diameter / c.fit;
      var STEP = 2;
      var from = -RUNUP - 300;
      var N = Math.ceil((S_END - from) / STEP);
      var rolled = null;
      function centre(s) {
        var p = pointAt(s);
        var u = offCord(s);
        return { x: p.x + u.x * R, y: p.y + u.y * R };
      }
      function build() {
        if (rolled) return;
        rolled = new Float32Array(N + 1);
        var prev = centre(from);
        for (var i = 1; i <= N; i++) {
          var q = centre(from + i * STEP);
          rolled[i] = rolled[i - 1] + Math.hypot(q.x - prev.x, q.y - prev.y);
          prev = q;
        }
      }
      return {
        el: el,
        seconds: c.seconds,
        prepare: build,
        place: function (s) {
          build();
          var f = Math.min(Math.max((s - from) / STEP, 0), N - 1e-6);
          var i = Math.floor(f);
          var dist = rolled[i] + (rolled[i + 1] - rolled[i]) * (f - i);
          var q = centre(s);
          var deg = (-dist / R) * (180 / Math.PI);
          el.style.transform =
            'translate(' + q.x * scale + 'px,' + q.y * scale + 'px) rotate(' + deg + 'deg) scale(' + k * scale + ') translate(' + -w / 2 + 'px,' + -h / 2 + 'px)';
          el.classList.toggle('is-behind', isBehind(s));
        }
      };
    }

    /* Not round: each bit of the outline meets the route in turn, and the body
       turns so that bit faces the cord, so it rocks and lurches as it goes. */
    function lumpy(el, c) {
      var w = +el.getAttribute('width');
      var h = +el.getAttribute('height');
      var k = c.diameter / c.fit;
      var H = c.hull;
      var step = H.perimeter / H.n;
      return {
        el: el,
        seconds: c.seconds,
        place: function (s) {
          var d = (s - S_START) / k;
          var l = ((d % H.perimeter) + H.perimeter) % H.perimeter;
          var f = l / step;
          var i = Math.floor(f) % H.n;
          var j = (i + 1) % H.n;
          var t = f - Math.floor(f);
          function lerp(a) {
            return a[i] + (a[j] - a[i]) * t;
          }
          var px = lerp(H.x);
          var py = lerp(H.y);
          var nx = lerp(H.nx);
          var ny = lerp(H.ny);
          var p = pointAt(s);
          var u = offCord(s);
          var phi = Math.atan2(-u.y, -u.x) - Math.atan2(ny, nx);
          var cs = Math.cos(phi);
          var sn = Math.sin(phi);
          var vx = (px - w / 2) * k;
          var vy = (py - h / 2) * k;
          el.style.transform =
            'translate(' + (p.x - (cs * vx - sn * vy)) * scale + 'px,' + (p.y - (sn * vx + cs * vy)) * scale + 'px) rotate(' + (phi * 180) / Math.PI + 'deg) scale(' + k * scale + ') translate(' + -w / 2 + 'px,' + -h / 2 + 'px)';
          el.classList.toggle('is-behind', isBehind(s));
        }
      };
    }

    var skate = vehicle(car, SKATE, carWidth);
    var others = [];
    ORDER.forEach(function (id) {
      var el = box.querySelector('[data-hev-ride="' + id + '"]');
      if (!el) return;
      if (id === 'skier') others.push(vehicle(el, SKIER, function () { return SKIER.width; }));
      else if (ROLLERS[id].hull) others.push(lumpy(el, ROLLERS[id]));
      else others.push(roller(el, ROLLERS[id]));
    });

    /* Rides 4, 8, 12 ... are the others in turn; the rest are the skate. */
    function pick(n) {
      if (!others.length || n % EVERY !== 0) return skate;
      return others[(n / EVERY - 1) % others.length];
    }
    /* Fetch a rider's art (and build its roll) one ride before it's due. */
    function prepare(rider) {
      var el = rider.el;
      if (!el.getAttribute('src') && el.getAttribute('data-src')) el.setAttribute('src', el.getAttribute('data-src'));
      if (rider.prepare) {
        if (window.requestIdleCallback) requestIdleCallback(rider.prepare);
        else setTimeout(rider.prepare, 0);
      }
    }

    var rideNo = 0;
    var rider = null;
    var rideStart = 0;
    var rideLen = 0;
    var nextStart = performance.now() + FIRST_DELAY * 1000;
    var raf = null;

    function frame(now) {
      if (!rider && now >= nextStart) {
        rideNo++;
        rider = pick(rideNo);
        prepare(pick(rideNo + 1));
        rideStart = now;
        rideLen = rider.seconds * 1000 * ((S_END - S_START) / (S_END - EXIT_EXTRA - S_START));
        nextStart = now + INTERVAL_SECONDS * 1000;
        rider.el.classList.add('is-visible');
      }
      if (rider) {
        var u = (now - rideStart) / rideLen;
        if (u >= 1) {
          rider.el.classList.remove('is-visible');
          rider = null;
        } else {
          rider.place(S_START + (S_END - S_START) * u);
        }
      }
      raf = requestAnimationFrame(frame);
    }
    function start() {
      if (raf !== null) return;
      /* Drop a ride that was cut off while the section was out of view. */
      if (rider) {
        rider.el.classList.remove('is-visible');
        rider = null;
      }
      nextStart = Math.max(nextStart, performance.now() + 1000);
      raf = requestAnimationFrame(frame);
    }
    function stop() {
      if (raf !== null) {
        cancelAnimationFrame(raf);
        raf = null;
      }
    }

    var onScreen = false;
    function sync() {
      if (onScreen && !document.hidden) start();
      else stop();
    }
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      sync();
    }).observe(box);
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('resize', measure);
  }

  function boot() {
    document.querySelectorAll('[data-hev-cord]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
